module.exports = __webpack_public_path__ + "img/meter-operator.5ee01de7.jpg";